<template>
  <a-modal v-model="visible" :title="title" :width="1200" destroyOnClose class="month-detail-modal">
    <div style="margin-top: 8px">
      <j-dict-select-tag
        style="width: 170px; margin-right: 15px"
        placeholder="请选择年级"
        v-model="queryParam.gradeId"
        dictCode="school_grade,grade_name,id,0=delete_flag order by sort_order"
        :isShowEmpty="false"
        @select="$set(queryParam, 'classId', undefined)"
        @clear="$set(queryParam, 'classId', undefined)"
      />
      <j-dict-select-tag
        style="width: 170px; margin-right: 15px"
        placeholder="请选择班级"
        v-model="queryParam.classId"
        :dictCode="
          'school_class,name,id,grade_id=' + (!queryParam.gradeId ? -1 : queryParam.gradeId)
        "
        :async="true"
        :disabled="!queryParam.gradeId"
        :isShowEmpty="false"
      />
      <a-button type="primary" @click="loadData" icon="search" :loading="loading">查询</a-button>
    </div>
    <TableList
      style="width: 100%; margin-top: 5px"
      rowKey="teacherId"
      :columns="columns"
      bordered
      :tableData="dataSource"
      :rowSelection="{ selectedRowKeys: selectedRowKeys, onChange: onSelectChange }"
      :loading="loading"
      :scroll="{
        y: 500,
      }"
    />
    <!--:pagination="ipagination"-->
    <!--@change="changeTable"-->
    <div slot="footer" class="footer flex-align-end">
      <a-button @click="hideModal">取消</a-button>
      <a-button
        icon="export"
        :loading="exportXlsLoading"
        style="margin: 0 15px; border-color: #13b999; background-color: #13b999; color: #fff"
        @click="handleExportXls(title)"
      >
        导出
      </a-button>
      <a-popconfirm
        title="确定要提醒吗？"
        ok-text="确认"
        cancel-text="取消"
        @confirm="teacherUseOneRemind()"
      >
        <a-button
          type="primary"
          :disabled="!selectedRowKeys.length"
          :loading="remindLoading"
          style="margin: 0"
        >
          确认提醒
        </a-button>
      </a-popconfirm>
    </div>
    <!--教师关怀模态框-->
    <TeacherCareModal ref="teacherCareModalRef" />
  </a-modal>
</template>
<script>
import { JeecgListMixin } from '@/mixins/JeecgListMixin'
import TableList from '@comp/chart/TableList.vue'
import { getAction } from '@api/manage'
import TeacherCareModal from '@/comUi/TeacherCareModal'

export default {
  name: 'TeacherUsageModal',
  mixins: [JeecgListMixin],
  components: {
    TableList,
    TeacherCareModal,
  },
  props: {
    title: {
      type: String,
      default: '教师使用情况',
    },
    tableData: {
      type: Array,
      default: () => [],
    },
    url: {
      type: Object,
      default: () => ({
        list: '/statistic/teacherSituation',
        // exportXlsUrl: '/schoolEvaluationRecord/exportXls',
        // 教师使用情况导出
        exportXlsUrl: '/statistic/teacherSituationExport',
      }),
    },
  },
  data() {
    return {
      visible: false,
      loading: false,
      disableMixinCreated: true,
      remindLoading: false,
      columns: [
        {
          title: '排名',
          dataIndex: 'index',
          align: 'center',
          width: 60,
          customRender: (_, record, index) => index + 1,
        },
        {
          title: '班级',
          dataIndex: 'className',
          align: 'center',
        },
        {
          title: '教师姓名',
          dataIndex: 'teacherName',
          align: 'center',
          customRender: (_, record) => {
            return (
              <div
                style="color: #189EFF;cursor: pointer;"
                onClick={() => this.viewTeacherCare(record)}
              >
                {record.teacherName}
              </div>
            )
          },
        },
        {
          title: '未处理提醒',
          dataIndex: 'unDealWarnCnt',
          align: 'center',
          sorter: (a, b) => a.unDealWarnCnt - b.unDealWarnCnt,
          customRender: (_, record) => {
            return (
              <div style={{ color: record.unDealWarnCnt > 0 ? '#FF4D4F' : '' }}>
                {record.unDealWarnCnt}
              </div>
            )
          },
        },
        {
          title: '访问次数',
          dataIndex: 'visitCnt',
          align: 'center',
          sorter: (a, b) => a.visitCnt - b.visitCnt,
        },
        {
          title: '操作',
          dataIndex: 'teacherlRemind',
          align: 'center',
          // scopedSlots: { customRender: 'teacherlRemind' },
          customRender: (_, record) => {
            return (
              <a-popconfirm
                title="确定要提醒吗？"
                ok-text="确认"
                cancel-text="取消"
                onConfirm={() => this.teacherRemindList(record)}
              >
                <span style={{ color: '#1890ff', cursor: 'pointer' }}>提醒</span>
              </a-popconfirm>
            )
          },
        },
      ],
    }
  },
  methods: {
    async showModal(data) {
      this.visible = true
      this.selectedRowKeys = []
      this.queryParam = data
      if (this.tableData.length) {
        this.dataSource = this.tableData
      } else {
        await this.loadData()
      }
      this.setSelectKeys()
    },
    async loadData() {
      this.loading = true
      const { success, result } = await getAction(this.url.list, this.queryParam)
      this.loading = false
      if (success) {
        this.dataSource = result
      }
    },
    setSelectKeys() {
      this.selectedRowKeys = this.dataSource
        .filter((item) => item.unDealWarnCnt > 0)
        .map((item) => item.teacherId)
    },
    hideModal() {
      this.visible = false
    },
    // 查看教师关怀
    viewTeacherCare(data) {
      data.name = data.teacherName
      data.id = data.teacherId
      this.$refs.teacherCareModalRef.show(data)
    },
    teacherRemindList(record) {
      const id = record.teacherId
      const customText =
        record.teacherName +
        '老师您好，您收到一条来自后台' +
        '的提醒消息，本周您还有' +
        record.unDealWarnCnt +
        '条提醒未处理，请及时跟进处理。'

      const requestData = {
        teacherId: id,
        text: customText,
      }
      //催办班主任提醒处理
      getAction('/aigoes/schoolClass/earlyWarning', requestData).then((res) => {
        console.log(res)
        if (res.success) {
          // this.$message.success('催办成功！');
          this.$notification['success']({
            message: '通知',
            description: '已提醒班主任！',
          })
        }
      })
    },
    // 教师使用情况一键提醒
    async teacherUseOneRemind() {
      console.log('教师使用情况一键提醒', this.selectedRowKeys.join(','))
      const deviceIdArr = new Set(
        this.dataSource
          .filter((item) => this.selectedRowKeys.includes(item.teacherId))
          .map((item) => item.deviceId)
      )
      this.remindLoading = true
      const res = await getAction('/statistic/teacherSituation', {
        ...this.queryParam,
        userIds: [...deviceIdArr].join(','),
        type: 1,
      })
      this.remindLoading = false
      const { success, result } = res
      if (success) {
        this.$message.success(result || '一键提醒成功')
      } else {
        this.$message.error(result || '一键提醒失败')
      }
    },
    changeTable(pagination) {
      this.ipagination = pagination
    },
  },
}
</script>
<style scoped lang="less">
.month-detail-modal {
  /deep/ .ant-modal-title {
    font-size: 16px;
    font-weight: bold;
    color: #333;
  }
  /deep/ .ant-modal-body {
    min-height: 590px;
    padding: 10px 24px;
  }
  /deep/ .ant-modal-footer {
    padding-top: 16px;
    padding-bottom: 16px;
    border-top: 1px solid #ececec;
  }
  /deep/ .ant-table-hide-scrollbar {
    width: 100.7% !important;
  }
}
</style>
